/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';

// wwdev
import '@wwdev/bootstrap/index.js';
import '@wwdev/functions/index.js';
import './wwdev/forms/index';
import './wwdev/lazysizes/index.js';
import './wwdev/components/maps'
import './wwdev/components/select2'
import './wwdev/components/popover'
import './wwdev/default'
import './wwdev/webshop/index.js';
import '@wwdev/search';
import './wwdev/zipcode/index.js';
import '@wwdev/winkelwagen/form';
import '@wwdev/register';

// Externals
import '@fancyapps/fancybox';
import 'select2';
import './externals/flickity'
import './externals/wow';

// Sunrooms
import "@sunrooms/myaccount";
import "@sunrooms/webshop";

// Vendors
import './vendor/viewport-class-on-resize'
import './vendor/Product/Item'
import './vendor/Product/Configurator'

// Base
import './base/header';

// Sections
import './sections/highlight_projects'
import './sections/form_dealers';
import './sections/imageSlider';
import './sections/titleTextProductImage';
import './sections/projectenSlider';
import './sections/productVisual';